.card {
  --_accent: var(--action-primary);
  --_icono: var(--text-subtle);

  display: flex;
  flex-direction: column;
  gap: var(--s-5);
  min-width: 220px;
  padding: var(--s-7);
  border-radius: var(--r-panel);
  border: var(--bw-hair) solid var(--border-hair);
  background: var(--surface-card);
}
/* Tile del tablero: gris, sin borde, más chico; la regla se apaga cuando la cifra es cero. */
.card[data-tone="sunken"] {
  gap: var(--s-5);
  min-width: 0;
  padding: var(--s-7) var(--s-6);
  border-radius: var(--r-md);
  border-color: transparent;
  background: var(--surface-sunken);
}
.card[data-tone="sunken"] .cabecera {
  align-items: flex-start;
  min-height: 31px;
  gap: var(--s-4);
}
.card[data-tone="sunken"] .eyebrow {
  font-size: var(--fs-3xs);
  letter-spacing: var(--ls-label);
  line-height: 1.4;
  text-wrap: balance;
}
.card[data-tone="sunken"] .valor {
  font-size: 36px;
  line-height: 1;
}
.card[data-tone="sunken"] .regla {
  width: 24px;
}
.card[data-tone="sunken"] .periodo {
  font-size: var(--fs-3xs);
  line-height: 1.4;
  color: var(--text-muted);
}
.card[data-cero] .regla {
  background: var(--border-strong);
}
.card[data-channel="cartel"] {
  --_accent: var(--channel-cartel);
  --_icono: var(--channel-cartel);
}
.card[data-channel="organico"] {
  --_accent: var(--channel-organico);
  --_icono: var(--channel-organico);
}
.card[data-channel="pauta"] {
  --_accent: var(--channel-pauta);
  --_icono: var(--channel-pauta);
}

.cabecera {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--s-4);
}
.eyebrow {
  font-family: var(--font-body);
  font-size: var(--fs-2xs);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--ls-eyebrow);
  text-transform: uppercase;
  color: var(--text-muted);
}
.icono {
  color: var(--_icono);
}
.cifra {
  display: flex;
  align-items: baseline;
  gap: var(--s-3);
}
.valor {
  font-family: var(--font-display);
  font-size: var(--fs-5xl);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--ls-heading);
  line-height: 1.1;
  color: var(--text-strong);
  font-variant-numeric: tabular-nums;
}
.unidad {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--text-muted);
}
.regla {
  display: block;
  width: 28px;
  height: var(--bw-thick);
  border-radius: var(--r-full);
  background: var(--_accent);
}
.pie {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--s-4);
}
.delta {
  display: inline-flex;
  align-items: center;
  gap: var(--s-1);
  font-family: var(--font-mono);
  font-size: var(--fs-2xs);
  font-weight: var(--fw-semibold);
  font-variant-numeric: tabular-nums;
  color: var(--text-danger);
}
.delta[data-sube] {
  color: var(--text-success);
}
.periodo {
  font-family: var(--font-body);
  font-size: var(--fs-2xs);
  color: var(--text-subtle);
}
